
























































































































































































































import { faArrowRight } from '@fortawesome/pro-regular-svg-icons';
import Vue from 'vue';
import { Resolve } from 'vue-di';
import { Component, Watch } from 'vue-property-decorator';
import Footer from '~/components/common/Footer/Footer.vue';
import Header from '~/components/common/Header/Header.vue';
import theme from '~/settings/theme';
import LayoutModule from '~/store/layout';
import SectionModule from '~/store/section';
import SessionModule from '~/store/session';

@Component<DefaultLayout>({
    components: {
        Header,
        Footer,
    },    
      mounted() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if ((this as any).$meta) (this as any).$meta().refresh();
        const anySelection = this.sectionStore.anyPathSelected;
        if (!anySelection) {
            this.$router.push('/');
        }

        // Added event listener to check window resizing
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        // Check for E-Consent parameter in various formats
        const routeQuery = this.$route.query;
        const routePath = this.$route.path;
        
        const isEconsentPath = 
            routeQuery.path === 'econsent' || // Standard format: ?path=econsent
            routePath.includes('/path=econsent') || // Unusual format: /path=econsent
            routePath.includes('/?path=econsent') || // Another format with slash
            routeQuery.econsent === '' || // Possible format: ?econsent
            routeQuery.econsent === 'true'; // Possible format: ?econsent=true
        
        if (isEconsentPath) {
             // Add route guard to handle navigation
            this.$router.beforeEach((to, from, next) => {
                // End any existing loaders to prevent stuck loading state
                if (this.$wait.is('nuxt')) {
                    this.$wait.end('nuxt');
                }
                next();
            });
        }   
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    icons: {
        faArrowRight
    },
})
export default class DefaultLayout extends Vue {

    @Resolve
    public session!: SessionModule;

    @Resolve
    public layout!: LayoutModule;

    @Resolve
    sectionStore!: SectionModule;    
    
    created() {
        try {        
            // Handle E-Consent parameter case - check multiple possible formats
            const routeQuery = this.$route.query;
            const routePath = this.$route.path;
            
            // Check for query parameter in various formats
            const isEconsentPath = 
                routeQuery.path === 'econsent' || // Standard format: ?path=econsent
                routePath.includes('/path=econsent') || // Unusual format: /path=econsent
                routePath.includes('/?path=econsent') || // Another format with slash
                routeQuery.econsent === '' || // Possible format: ?econsent
                routeQuery.econsent === 'true'; // Possible format: ?econsent=true
                
            if (isEconsentPath) {
                this.activeMenuItems = this.sectionStore.activeUniqueMenuItems;
                // Find Patient section (id: 111)
                const patientSection = this.sectionStore.SECTIONS.find(section => section.id === 111);
                
                if (patientSection) {
                    // Find the E-Consent option (id: 3)
                    const eConsentOption = patientSection.options.find(option => option.id === 3);
                    if (eConsentOption) {
                        // Select the E-Consent path
                        this.sectionStore.handleSelectionPath({ 
                            section: patientSection, 
                            optionIndex: patientSection.options.indexOf(eConsentOption)
                        });
                        
                        // Check if we need to redirect
                        const currentPath = this.$route.path;                        // Check specifically for special pages
                        const isSpecialPage = 
                            currentPath === '/' || 
                            currentPath === '/success' || 
                            currentPath === '/success/' ||
                            currentPath === '/patient/patient-authorization-success' ||
                            currentPath === '/patient/patient-authorization-success/' ||
                            currentPath === '/not-eligible' ||
                            currentPath === '/thank-you' ||
                            currentPath === '/error' ||
                            currentPath === '/upload-documents-success';// Check if current path is part of E-Consent flow
                        const isEConsentPage = eConsentOption.menuItems.some(item => {
                            // Normalize both paths by ensuring they start with / and end with /
                            const menuPath = '/' + item.route.replace(/^\/|\/$/g, '') + '/';
                            const routePath = '/' + currentPath.replace(/^\/|\/$/g, '') + '/';
                            return routePath.includes(menuPath);
                        });
                        
                        // Redirect from landing page, special pages, or any non-E-Consent page
                        if (isSpecialPage || !isEConsentPage) {                            
                            // Start loader
                            this.$wait.start('nuxt');
                            this.ensureLoadingEndsAfterTimeout();
                            
                            // Use push instead of replace for more consistent navigation behavior
                            this.$router.push({
                                path: eConsentOption.menuItems[0].route,
                                query: { path: 'econsent' }
                            }).catch(err => {
                                // Handle navigation errors
                                console.error('Navigation error:', err);
                                this.$wait.end('nuxt');
                            });
                        } else {
                            console.warn('Already on E-Consent page, no redirect needed');
                        }
                        
                        // Update the activeMenuItems after selection is made
                        this.$nextTick(() => {
                            this.activeMenuItems = this.sectionStore.activeUniqueMenuItems;
                        });
                        return;
                    }
                }
                
                // Check if we were previously on E-Consent path but now the parameter is missing
                const wasOnEconsentPath = this.sectionStore.activeUniqueMenuItems && this.sectionStore.activeUniqueMenuItems.id === 3; // E-Consent option ID
                const missingEconsentParam = !isEconsentPath && wasOnEconsentPath;
                  // Only reset and redirect if we were previously on E-Consent path but now the parameter is missing
                // This prevents interference with normal flow navigation
                
                // Skip redirect for success page
                const currentPath = this.$route.path;
                const isSuccessPage = 
                   currentPath === '/' || 
                                currentPath === '/success' || 
                                currentPath === '/success/' ||
                                currentPath === '/patient/patient-authorization-success' ||
                                currentPath === '/patient/patient-authorization-success/' ||
                                currentPath === '/not-eligible' ||
                                currentPath === '/thank-you' ||
                                currentPath === '/error' ||
                                currentPath === '/upload-documents-success';// Check if current path is part of E-Consent flow
                    
                if (missingEconsentParam && !isSuccessPage) {
                    this.sectionStore.resetSelections();
                    this.$wait.start('nuxt');
                    this.$router.push('/');
                    return;
                }
                
                // Don't reset if user has made a selection in normal flow
                if (!this.sectionStore.activeUniqueMenuItems && !this.sectionStore.anyPathSelected && this.$route.path !== '/') {
                    this.$router.push('/');
                }
            } else {
                if(!this.sectionStore.activeUniqueMenuItems) {
                    this.sectionStore.resetSelections();
                    this.$router.push('/');
                }
            }
            
        } catch (error) {
            console.error('Error in default layout created hook:', error);
            this.sectionStore.resetSelections();
        }
    }

    @Watch('this.$route.query', { immediate: true })
    setTestPdf() {
        const testPDF = !!this.$route.query.testPDF && this.$route.query.testPDF === 'true';
        this.layout.setShowTestPDF(testPDF);
    }

    public isTablet = false;

    handleResize() {
        const isTabletNow = window.innerWidth <= 960;
        if (isTabletNow !== this.isTablet) {
            this.isTablet = isTabletNow;
            // Performing state change here only once when it resized from desktop to tablet
            if (this.isTablet) {
                this.layout.setDrawer(false);
            }
        }
    }

    public theme = theme;

    activeMenuItems = this.sectionStore.activeUniqueMenuItems || { navTitle: '', menuItems: [] };

    // Allows user to close the configuration drawer by hitting escape
    public get drawerItems() {
        return this.layout.drawerNavigation;
    }

    public get drawer() {
        return this.layout.drawer;
    }

    public set drawer(v) {
        this.layout.setDrawer(v);
    }

    public currentPath(route: string) {
        if (this.$route.path.endsWith('/') && !route.endsWith('/')) {
            return this.$route.path === route + '/';
        } else if (!this.$route.path.endsWith('/') && route.endsWith('/')) {
            return this.$route.path === route.slice(0, -1);
        }else {
            return this.$route.path === route;
        }
    }    
      
    public moveTo(url:string){
        const routeQuery = this.$route.query;
        const routePath = this.$route.path;
            
        // Check for query parameter in various formats
        const isEconsentPath = 
            routeQuery.path === 'econsent' || // Standard format: ?path=econsent
            routePath.includes('/path=econsent') || // Unusual format: /path=econsent
            routePath.includes('/?path=econsent') || // Another format with slash
            routeQuery.econsent === '' || // Possible format: ?econsent
            routeQuery.econsent === 'true'; // Possible format: ?econsent=true
            
        if (isEconsentPath) {
            // Only preserve the econsent parameter if we're in econsent mode
            const routeOptions = { path: url, query: { path: 'econsent' } };
                
            this.$router.push(routeOptions).catch(err => {
                console.error('Navigation error in moveTo:', err);
            });
        } else {
           this.$router.push(url)
        }
    }

    public get brkPoints() {
        return {
            'brk-xs': this.$vuetify.breakpoint.xs,
            'brk-xs-only': this.$vuetify.breakpoint.xsOnly,
            'brk-sm': this.$vuetify.breakpoint.sm,
            'brk-sm-only': this.$vuetify.breakpoint.smOnly,
            'brk-sm-and-down': this.$vuetify.breakpoint.smAndDown,
            'brk-sm-and-up': this.$vuetify.breakpoint.smAndUp,
            'brk-md': this.$vuetify.breakpoint.md,
            'brk-md-only': this.$vuetify.breakpoint.mdOnly,
            'brk-md-and-down': this.$vuetify.breakpoint.mdAndDown,
            'brk-md-and-up': this.$vuetify.breakpoint.mdAndUp,
            'brk-lg': this.$vuetify.breakpoint.lg,
            'brk-lg-only': this.$vuetify.breakpoint.lgOnly,
            'brk-lg-and-down': this.$vuetify.breakpoint.lgAndDown,
            'brk-lg-and-up': this.$vuetify.breakpoint.lgAndUp,
            'brk-xl': this.$vuetify.breakpoint.xl,
            'brk-xl-only': this.$vuetify.breakpoint.xlOnly,
        };
    }

    private ensureLoadingEndsAfterTimeout() {
        // End the loader after a maximum of 5 seconds to prevent infinite loading
        setTimeout(() => {
            if (this.$wait.is('nuxt')) {
                this.$wait.end('nuxt');
            }
        }, 5000);
    }
}
